export default __webpack_public_path__ + "static/media/sling.fd39969f.png";